import cls from "./customInnerPage.module.scss";
import {
    FacebookIcon,
    FacebookShareButton,
    PinterestIcon,
    PinterestShareButton,
    TwitterIcon,
    TwitterShareButton
} from "next-share";
import {domainUrl} from "../../../helper";
import React, {FC} from "react";
import {TranslationsType} from "../../../types/homePageTypes";

interface IProps {
    dbName: string;
    productSlug: string;
    domain: string;
    translationsData: TranslationsType;
}

const CustomSocialLinks: FC<IProps> = (
    {
        dbName,
        productSlug,
        domain,
        translationsData
    }
) => (
    <div className={cls["socialLinksBox"]}>
        <div>
            {translationsData?.PostShare}
        </div>
        <FacebookShareButton url={`https://${dbName}/products/${productSlug}`}>
            <FacebookIcon size={32} round/>
        </FacebookShareButton>
        <TwitterShareButton url={`https://${dbName}/products/${productSlug}`}>
            <TwitterIcon size={32} round/>
        </TwitterShareButton>
        <PinterestShareButton
            url={`https://${dbName}/products/${productSlug}`}
            media={domainUrl(`${dbName}/storage/${domain}/configuration/logo/logo.webp`)}
        >
            <PinterestIcon size={32} round/>
        </PinterestShareButton>
    </div>
);

export default CustomSocialLinks